module.exports = __webpack_public_path__ + "static/media/0024_IMG_FE_LE_SOL_CARRELAGE_EXISTANT.920ab761.webp";